module.exports = __webpack_public_path__ + "img/log_in.29fc047a.svg";